<template>
    <div>
        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">
                <ol class="breadcrumb noprint">
                    <li>
                        <a href="#/">
                            <i class="fa fa-home" aria-hidden="true"></i> INICIAL
                        </a>
                    </li>
                    <li class="active"> <i class="fa fa-suitcase" aria-hidden="true"></i> CONTRATOS SEM MAC</li>
                </ol>

                <list-contratos-sem-mac></list-contratos-sem-mac>
            </div>
        </div>
    </div>
</template>
<script>
import { ListContratosSemMac } from "../../components/exports";

export default {
    components: {
        ListContratosSemMac
    },
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    }
};
</script>
